import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { CalendarEvent } from 'calendar-utils';
import { setHours, setMinutes, startOfDay, endOfDay, isSameMonth, isSameDay, subDays, addDays, endOfMonth, addHours } from 'date-fns';
import { CalendarView, CalendarEventTimesChangedEvent, CalendarEventAction } from 'angular-calendar';
import { BsModalRef } from 'ngx-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Subject } from 'rxjs';

const colors: any = {
  limeGreen: {
    primary: '#00FF00',
    secondary: '#FAE3E3',
  },
  yellowGreen: {
    primary: '#ADFF2F',
    secondary: '#D1E8FF',
  },
  info: {
    primary: '#4c86a0',
    secondary: '#FDF1BA',
  },
  aqua: {
    primary: "#00FFFF"
  }
};

@Component({
  selector: 'app-agent-slots-calender',
  templateUrl: './agent-slots-calender.component.html',
  styleUrls: ['./agent-slots-calender.component.scss']
})
export class AgentSlotsCalenderComponent implements OnInit {

  @Input() dialogData: any

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  refresh: Subject<any> = new Subject();

  events: CalendarEvent[] = [];

  activeDayIsOpen: boolean = true;

  constructor(private modal: NgbModal, public bsModalRef: BsModalRef) { }

  ngOnInit() {
    // {
    //   start: subDays(startOfDay(new Date()), 1),
    //   end: addDays(new Date(), 1),
    //   title: 'A 3 day event',
    //   color: colors.red,
    //   actions: this.actions,
    //   allDay: true,
    //   resizable: {
    //     beforeStart: true,
    //     afterEnd: true,
    //   },
    //   draggable: true,
    // },
    // {
    //   start: startOfDay(new Date()),
    //   title: 'An event with no end date',
    //   color: colors.yellow,
    //   actions: this.actions,
    // },
    // {
    //   start: subDays(endOfMonth(new Date()), 3),
    //   end: addDays(endOfMonth(new Date()), 3),
    //   title: 'A long event that spans 2 months',
    //   color: colors.blue,
    //   allDay: true,
    // },
    // {
    //   start: addHours(startOfDay(new Date()), 2),
    //   end: addHours(new Date(), 2),
    //   title: 'A draggable and resizable event',
    //   color: colors.yellow,
    //   actions: this.actions,
    //   resizable: {
    //     beforeStart: true,
    //     afterEnd: true,
    //   },
    //   draggable: true,
    // },
    this.dialogData.slots.forEach(slot => {

      let startDate = new Date(Date.parse(moment.utc(slot.startTime).format("MM/DD/YYYY HH:mm")))
      let endDate = new Date(Date.parse(moment.utc(slot.endTime).format("MM/DD/YYYY HH:mm")))
      let showStick = false

      if (startDate.getDate() != endDate.getDate()) {
        showStick = true
      } else {
        showStick = false
      }
      if (slot.slot_booked) {
        let slot1 = {
          title: 'Booked ' + moment.utc(slot.startTime).format("MMM DD , YYYY HH:mm") + ' - ' + moment.utc(slot.endTime).format("MMM DD , YYYY HH:mm"),
          start: setHours(setMinutes(startDate, startDate.getMinutes()), startDate.getHours()),
          end: setHours(setMinutes(endDate, endDate.getMinutes()), endDate.getHours()),
          color: startDate.getDate() == endDate.getDate() ? colors.yellowGreen : colors.aqua,
          actions: this.actions,
          allDay: true,
          resizable: {
            beforeStart: true,
            afterEnd: true,
          },
          draggable: true,
          stick: showStick
        }
        this.events.push(slot1)
      } else {
        let slot1 = {
          title: 'Available ' + moment.utc(slot.startTime).format("MMM DD , YYYY HH:mm") + ' - ' + moment.utc(slot.endTime).format("MMM DD , YYYY HH:mm"),
          start: setHours(setMinutes(startDate, startDate.getMinutes()), startDate.getHours()),
          end: setHours(setMinutes(endDate, endDate.getMinutes()), endDate.getHours()),
          color: startDate.getDate() == endDate.getDate() ? colors.info : colors.limeGreen,
          actions: this.actions,
          allDay: true,
          resizable: {
            beforeStart: true,
            afterEnd: true,
          },
          draggable: true,
          stick: showStick

        }
        this.events.push(slot1)
      }
    });
  }

  getTime(date) {
    return moment.utc(date).format('MMM DD, YYYY HH:mm')
  }



  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    this.modal.open(this.modalContent, { size: 'lg' });
  }

  addEvent(): void {
    this.events = [
      ...this.events,
      {
        title: 'New event',
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        color: colors.red,
        draggable: true,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
      },
    ];
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  close() {
    this.bsModalRef.hide()
  }
}
